
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Dashboards.Common
// Microsoft.TeamFoundation.Dashboards.WebApi
// Microsoft.TeamFoundation.Server.WebAccess.Dashboards.Plugins
// Microsoft.TeamFoundation.Dashboards.Server
//----------------------------------------------------------


export module AppStoreConstants {
    export const DashboardWidgetCatalogTargetContributionID = "ms.vss-dashboards-web.widget-catalog";
    export const DashboardWidgetConfigurationCatalogTargetContributionID = "ms.vss-dashboards-web.widget-configuration";
    export const WidgetTypeContributionID = "ms.vss-dashboards-web.widget";
    export const WidgetConfigurationTypeContributionID = "ms.vss-dashboards-web.widget-configuration";
}

export module BowTieClassNames {
    export const Bowtie = "bowtie";
    export const Icon = "bowtie-icon";
    export const ArrowOpenIcon = "bowtie-arrow-open";
    export const BrandVisualStudioIcon = "bowtie-brand-visualstudio";
    export const Comment = "bowtie-comment";
    export const SideBySide = "side-by-side";
}

export module DashboardFeatureIds {
    export const NewExperience = "ms.vss-dashboards-web.dashboards-new-experience-feature";
}

export module DashboardPageDataProviderKeys {
    export const MaxDashboardPerGroup = "MaxDashboardPerGroup";
    export const MaxWidgetsPerDashboard = "MaxWidgetsPerDashboard";
    export const IsStakeholder = "IsStakeholder";
    export const Dashboard = "Dashboard";
    export const IsNewDashboardFeatureEnabled = "IsNewDashboardFeatureEnabled";
    export const TeamMembersOf = "TeamMembersOf";
    export const RouteId = "RouteId";
}

export module DashboardProviderPropertyBagNames {
    export const Dashboards = "ms.vss-dashboards-web.dashboards-data-provider";
    export const DashboardsLegacy = "ms.vss-dashboards-web.dashboards-legacy-data-provider";
    export const DashboardsNavigation = "ms.vss-dashboards-web.dashboards-nav-data-provider";
    export const TeamContextData = "ms.vss-dashboards-web.dashboards-team-context-data-provider";
    export const TeamData = "ms.vss-dashboards-web.dashboards-team-data-provider";
    export const TeamList = "ms.vss-dashboards-web.dashboards-team-list-data-provider";
    export const MyTeamList = "ms.vss-dashboards-web.my-team-list-data-provider";
    export const TeamMemberships = "ms.vss-dashboards-web.dashboards-team-memberships-provider";
    export const DashboardsContent = "ms.vss-dashboards-web.dashboards-content-provider";
    export const DashboardDirectoryData = "ms.vss-dashboards-web.dashboards-directory-data-provider";
    export const MyDashboards = "ms.vss-dashboards-web.my-dashboards-data-provider";
    export const AllDashboards = "ms.vss-dashboards-web.all-dashboards-data-provider";
    export const MruDashboard = "ms.vss-dashboards-web.mru-dashboard-data-provider";
    export const FavoriteDashboards = "ms.vss-dashboards-web.favorite-dashboards-data-provider";
}

export module DashboardRouteIds {
    export const NewExperience = "ms.vss-dashboards-web.dashboards-new-experience-route";
    export const NewExperienceEmbedded = "ms.vss-dashboards-web.dashboards-new-experience-route-embed";
}

export module DashboardSecurity {
    export const SecurityNamespaceGuid = "8ADF73B7-389A-4276-B638-FE1653F7EFC7";
}

export module DashboardsPermissions {
    export const Read = 1;
    export const Create = 2;
    export const Edit = 4;
    export const Delete = 8;
    export const ManagePermissions = 16;
    export const MaterializeDashboards = 32;
}

export module DashboardsProviderNames {
    export const Dashboards = "TFS.Dashboards.Widgets.Provider.DashboardsDataProvider";
    export const DashboardsLegacy = "TFS.Dashboards.Widgets.Provider.DashboardsLegacyDataProvider";
    export const TeamContext = "TFS.Dashboards.Widgets.Provider.TeamContextDataProvider";
    export const TeamData = "TFS.Dashboards.Widgets.Provider.TeamDataProvider";
    export const TeamList = "TFS.Dashboards.Widgets.Provider.TeamListDataProvider";
    export const MyTeamList = "Dashboards.MyTeamListDataProvider";
    export const TeamMemberships = "TFS.Dashboards.Widgets.Provider.TeamMembershipsDataProvider";
    export const DashboardsContent = "TFS.Dashboards.Widgets.Provider.DashboardsContentDataProvider";
    export const DashboardDirectoryData = "TFS.Dashboards.Widgets.Provider.DashboardsDirectoryDataProvider";
    export const DashboardTeamPanelDataProvider = "DashboardsHub.TeamPane.DataProvider";
    export const MyDashboards = "Dashboards.Mine.DataProvider";
    export const AllDashboards = "Dashboards.All.DataProvider";
    export const MruDashboard = "Dashboards.Mru.DataProvider";
    export const FavoriteDashboards = "Dashboards.DirectoryFavorites.DataProvider";
}

export module DashboardUrlParams {
    export const ActiveDashboardId = "activeDashboardId";
    export const IsNew = "isNew";
}

export module DashboardWidgetLimits {
    export const MaxDashboardNameLength = 32;
    export const MaxDashboardDescriptionLength = 128;
    export const MaxWidgetNameLength = 256;
    export const MaxWidgetTypeLength = 1000;
    export const MaxWidgetArtifactIdLength = 256;
    export const MaxWidgetSettingsVersionLength = 256;
    export const MaxWidgetArtifactContextLength = 512;
    export const MaxWidgetLegacySettingsLength = 4000;
    export const MaxWidgetSettingsLength = 16000;
    export const MinRequiredRefreshInterval = 30;
    export const MaxRowSpan = 10;
    export const MaxColumnSpan = 10;
}

export module DomClassNames {
    export const WidgetHideMenu = "no-height";
    export const WidgetMenuContainer = "widget-menu-header";
    export const WidgetLightboxMenuContainer = "widget-lightbox-menu-header";
    export const WidgetMenuSubMenuContainer = "ellipsis-menubar";
    export const EllipsisIcon = "icon-ellipsis";
    export const DeleteIcon = "bowtie-icon bowtie-edit-delete";
    export const AddIconThin = "bowtie-icon bowtie-math-plus";
    export const SettingsIconGrey = "icon-settings";
    export const ConfigureWidgetIcon = "bowtie-icon bowtie-settings-gear";
    export const PinIcon = "icon-pin";
    export const WidgetSearchTermInput = "widget-searchterm-input";
    export const WidgetSearchButton = "widget-search-button";
    export const WidgetSearchContainer = "widget-search-container";
    export const Icon = "icon";
    export const ManagerDialog = "dashboards-manager-dialog";
    export const ManagerNewDashboardInput = "new-dashboard-name-input";
    export const ManagerNewDashboardButton = "new-dashboard-name-button";
    export const ManagerDashboardListContainer = "dashboard-list-container";
    export const ManagerDashboardListItem = "dashboard-list-item";
    export const ManagerDashboardListItemName = "dashboard-list-item-name";
    export const ManagerDashboardListItemDelete = "dashboard-list-item-delete";
    export const ManagerListHeaderContainer = "dashboard-list-header-container";
    export const ManagerListHeaderName = "dashboard-list-header-name";
    export const ManagerListHeaderAutorefresh = "dashboard-list-header-autorefresh";
    export const ManagerCreateNewDashboardTextbox = "new-dashboardname-textbox";
    export const ManagerCreateNewDashboardButton = "new-dashboardname-create-button";
    export const ManagerMessageArea = "dashboard-manager-message-area";
    export const DashboardAddWidget = "add-widget-button";
    export const AddWidgetEmptySearchText = "widget-search-watermark";
    export const WidgetEditMenuButtonContainer = "widget-edit-menu-button-container";
    export const WidgetEditMenuButton = "widget-edit-menu-button";
    export const WidgetHostInGridster = "widgethost";
    export const ToggleForDashboardEdit = "menu-toggle-button";
    export const LightboxButton = "lightbox-button";
    export const DisabledColor = "disabled-color";
}

export module DomIds {
    export const DashboardsToolbarContainerID = "dashboards-toolbar-container";
    export const DashboardsWidgetsContainerID = "widgets-container";
    export const ManagerButton = "dashboard-management";
    export const DashboardManager_CreateNewDashboard_Textbox = "dashboard-manager-createnew";
}

export module JQuerySelectors {
    export const MenuFocus = ".menu-focus-receiver";
    export const DataGridWidgetIdAttribute = "data-widget-id";
    export const ManagerListID = "data-id";
}

export module JsonIslandDomClassNames {
    export const DefaultDashboardId = "dashboard-data-defaultDashboardId";
    export const Dashboards = "dashboard-data-dashboards";
    export const DefaultDashboardWidgets = "dashboard-data-defaultDashboardWidgets";
    export const MaxWidgetsPerDashboards = "dashboard-data-maxWidgets";
    export const MaxDashboardsPerGroup = "dashboard-data-maxDashboards";
    export const IsStakeholder = "user-data-isStakeholder";
}

export module Permissions {
    export const Read = 1;
    export const Edit = 2;
    export const Manage = 4;
    export const ManagePermissions = 8;
}

export module TfsCommands {
    export const WidgetConfigurationAction = "widget-configuration";
    export const DashboardCreate = "create-dashboard";
    export const DashboardManage = "manage-dashboard";
    export const PushToDashboard = "add-to-dashboard";
    export const PinToDashboard = "pin-to-dashboard";
    export const WidgetRemoveAction = "remove-widget";
}

export module WidgetDataProviderNames {
    export const CollectionTimeZone = "TFS.Dashboards.Widgets.Provider.CollectionTimeZoneDataProvider";
    export const OtherLinksWidgetData = "TFS.Dashboards.Widgets.Provider.OtherLinksWidgetDataProvider";
    export const LegacyProjectData = "TFS.Dashboards.Widgets.Provider.LegacyProjectDataProvider";
    export const TeamMembersWidgetData = "TFS.Dashboards.Widgets.Provider.TeamMembersWidgetDataProvider";
}

export module WidgetDataProviderPropertyBagNames {
    export const CollectionTimeZoneData = "ms.vss-dashboards-web.collection-time-zone-data-provider";
    export const OtherLinksWidgetData = "ms.vss-dashboards-web.other-links-data-provider";
    export const LegacyProjectData = "ms.vss-dashboards-web.legacy-project-data-provider";
    export const TeamMembersWidgetData = "ms.vss-dashboards-web.team-members-widget-data-provider";
}

export module WidgetDomClassNames {
    export const WidgetContainer = "widget";
    export const DarkWidget = "dark-widget";
    export const ClickableWidgetContainer = "clickable";
    export const WidgetDescription = "description";
    export const TruncatedTextWithEllipsis = "truncated-text-ellipsis";
    export const NoBulletList = "no-bullets";
    export const Title = "title";
    export const SubTitle = "subtitle";
    export const IconContainer = "icon-container";
    export const LinkWithIconAndText = "link-with-icon-text";
    export const LinkWithIconAndTextList = "link-with-icon-text-list";
    export const DaysRemaining = "days-remaining";
    export const UserStoryProgress = "user-story-progress";
    export const DaysProgressBar = "days-progress-bar";
    export const WorkProgressBar = "work-progress-bar";
}

export module WidgetIds {
    export const TCMChartContribution = "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.TcmChartWidget";
    export const WITChartContribution = "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.WitChartWidget";
    export const BuildChartContribution = "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.BuildChartWidget";
    export const QueryScalarContribution = "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.QueryScalarWidget";
    export const CodeScalarContribution = "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.CodeScalarWidget";
    export const MarkDownContribution = "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.MarkdownWidget";
    export const TestResultsFailureTrendContribution = "ms.vss-test-web.Microsoft.VisualStudioTeamServices.Dashboards.TestResultsFailureTrendWidget";
    export const TestResultsDurationTrendContribution = "ms.vss-test-web.Microsoft.VisualStudioTeamServices.Dashboards.TestResultsDurationTrendWidget";
    export const TestResultsTrendContribution = "ms.vss-test-web.Microsoft.VisualStudioTeamServices.Dashboards.TestResultsTrendWidget";
}

